/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export function getCustomerName (customer) {
  return [
    customer.lastName,
    customer.firstName
  ].filter((n) => typeof n === 'string').join(' ') || '???'
}

export function getCustomerDisplayName (customer) {
  return customer.name || getCustomerName(customer)
}
